import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Col, Row, Table } from "reactstrap";
import ErrorScreen from "../../error/ErrorScreen";
import getDataFromApi from "../../getDataFromApi";
import Loader from "../../Loader";
import YAML from 'yaml';

export default function DataConfiguration({ expData, query, id }) {
  const [data, setData] = useState();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    if (!query) {
      setData(expData);
      setLoading(false);
      return;
    }
    var url = `${window['ENV'].API_URL}/models/detailed/${id}/configuration`;
    url += query;
    getDataFromApi(url, "get")
      .then((r) => {
        if (r?.detail) alert(r.detail);
        else {
          setData(r);
          setLoading(false);
        }
      })
      .catch((e) => {
        setError(e.message);
        console.log(e);
      });
    return () => {
      setError();
    };
  }, [id, query, expData]);

  if (loading) return <Loader />;
  if (error || !data) return <ErrorScreen message={"No Data Found"} />;

  const formatValue = (key, value) => {
    if (Array.isArray(value)) {
      return value.length === 0 ? "None" : value.join(", ");
    } else if (typeof value === 'object' && value !== null) {
     
      if (value.apply === false) {
        return null;
      }

     
      if (Object.keys(value).length === 0) {
        return "None";
      }

     
      return Object.entries(value)
        .filter(([k, v]) => k !== 'apply') 
        .map(([k, v]) => `${k}: ${v}`) 
        .join(", "); 
    } else if (value === null || value === '') {
      return "None";
    }
    return value.toString();
  };

  const renderTable = (obj) => {
    return (
      <Table className="dataconfig_table text">

        <tbody>
          {Object.entries(obj)
           
            .filter(([key, value]) => !(typeof value === 'object' && value?.apply === false))
            .map(([key, value]) => {
              const formattedValue = formatValue(key, value);
              
              if (formattedValue === null) return null;
              return (
                <tr key={key} style={{borderBottom:'none'}}>
                  <td className="table-cell1 text">{key.replace(/_/g, ' ').replace(/^\w/, c => c.toUpperCase())}</td>
                  <td className="table-cell1 text">{formattedValue.replace(/_/g, ' ')}</td>
                </tr>
              );
            })}
        </tbody>
      </Table>
    );
  };

  return (
    Object.keys(data?.configuration).map((section) => {
      const sectionData = data?.configuration[section];
      
      if (Object.keys(sectionData).length === 0) return null;

      return (
        <div className="my-4 mt-0" key={section}>
          <div key={section}>
            <h6 className="p-2 ps-1">
              {section}
            </h6>
            <div className="p-2 pt-3 pb-1 collapse-child">
              <Row>
                <Col sm={12}>
                  {renderTable(sectionData)}
                </Col>
              </Row>
            </div>
          </div>
        </div>
      );
    })
  );
}
